import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthService, NbLoginComponent, NB_AUTH_OPTIONS } from '@nebular/auth';
import { ParametrosService } from '../../../@core/backend/common/services/parametros.service';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent extends NbLoginComponent {

  logoUrl: string;

  public get logo(): any {
    const result = { 'background-image': this.logoUrl };
    return result;
  }

  constructor(private _parametrosService: ParametrosService, service: NbAuthService, @Inject(NB_AUTH_OPTIONS) options: {}, cd: ChangeDetectorRef, router: Router) {
    super(service, options, cd, router);
  }
  ngOnInit(): void {
    this._parametrosService.getLogo().subscribe((res) => {
      if (res && res.Url)
        this.logoUrl = `url('${res.Url}')`;
      else
        this.logoUrl = "url('../../../../assets/images/logo.jpg')";
    });
  }
}